export default function initMenu() {

  const $body = $('body');

  $body.on('click', '.js-toggle-menu', function () {

    const $button = $('.js-toggle-menu');
    const $overlay = $('.js-menu-overlay');

    const isActive = $button.hasClass('active');

    if (isActive) {

      $button.removeClass('active');
      $body.removeClass('menu-open');

      $overlay.hide();

    } else {

      $overlay.show();

      setTimeout(() => {

        $body.addClass('menu-open');
        $button.addClass('active');

      }, 150);

    }

  });

}
